import { z } from "zod";

const envSchema = z.object({
  VITE_RUDDERSTACK_WRITE_KEY: z.string(),
  VITE_RUDDERSTACK_DATA_PLANE_URL: z.url(),
  VITE_AUTH0_DOMAIN: z.string().default("livance-dev.us.auth0.com"),
  VITE_AUTH0_CLIENTID: z.string().default("1IYeU8ROno8E4BkJ6vfOWuPiMKVWcku9"),
  VITE_AUTH0_AUDIENCE: z.string().default("dev-audience"),
  VITE_AUTH0_SCOPE: z.string().default("openid profile email offline_access api.all"),
  VITE_AUTH0_ISSUER: z.string().default("https://livance-dev.us.auth0.com/"),
  VITE_STYTCH_PUBLIC_TOKEN: z
    .string()
    .default("public-token-test-00000000-0000-0000-0000-000000000000"),
  VITE_STYTCH_BASE_URL: z.string().default("https://auth-dev.livance.com.br"),
  VITE_LAUNCHDARKLY_SDK_KEY: z.string(),
  VITE_SENTRY_DSN: z.string(),
  VITE_SENTRY_ENVIRONMENT: z.string(),
  VITE_FAVICON: z.string(),
  VITE_URL_NO_HTTPS: z.preprocess(
    (value) => (typeof value === "string" && value.trim() === "" ? undefined : value),
    z.string().default("app.livance.com.br"),
  ),
  VITE_HASURA_ENDPOINT: z.string().default("hasura.livance.com.br/v1/graphql"),
  VITE_HASURA_STYTCH_ENDPOINT: z.string().default("hasura-v2.livance.com.br/v1/graphql"),
  VITE_PAGARME_ENCRYPTED_KEY: z.string(),
  VITE_PAGARME_PUBLIC_KEY: z.string(),
  VITE_LIVANCE_API_URL: z.string(),
  VITE_EXPENSUM_URL: z.url(),
  VITE_ANIMUS_URL: z.url(),
  VITE_USER_PILOT_TOKEN: z.string(),
  VITE_AUTHUS_URL: z.url().default("http://localhost:3021"),
  VITE_CUSTOMER_IO_API_KEY: z.string(),
  VITE_ZENDESK_SNIPPET_KEY: z.string(),
  VITE_CANCELLATION_TYPE_FORM_URL: z.string(),
});

export const env = envSchema.parse(import.meta.env);
